<template>
    <input
        type="text"
        :name="name"
        :value="value"
    />
</template>
<script>
import Datepicker from 'vanillajs-datepicker/Datepicker';

export default {
    props: {
        name: {
            type: String,
            required: false,
        },

        value: {
            type: String,
            required: false,
        },

        options: {
            type: Object,
            required: false,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            datepicker: null,
        };
    },

    methods: {},

    mounted() {
        const options = Object.assign({}, {
            autohide: true,
            buttonClass: 'c-btn c-btn--small',
            format: 'yyyy-mm-dd',
        }, this.options);

        this.datepicker = new Datepicker(this.$el, options);
    },
};
</script>
